import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "ic-event-item",
	templateUrl: "./event-item.component.html",
	styleUrls: ["./event-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EventItemComponent {}
